import React from 'react';
import { Outlet } from 'react-router-dom';
import { Sidebar } from './Sidebar';

export const Layout: React.FC = () => (
  <div className="flex h-screen bg-bg">
    <Sidebar />
    <main className="min-w-0 flex-1 overflow-y-auto">
      <Outlet />
    </main>
  </div>
);
